var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPen01 = function SvgPen01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2 17.747V19.8H6.25294L19.3029 6.74997L17.25 4.69703L4.2 17.747ZM6.75 21L20.2929 7.45708C20.6834 7.06655 20.6834 6.43339 20.2929 6.04286L17.9571 3.70708C17.5666 3.31655 16.9334 3.31655 16.5429 3.70708L3 17.25V21H6.75Z"
  })));
};
export default SvgPen01;